export default {
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    let filter = 'situacao not in ("ENVIADA_ADMIN")';
    if (state.searchText) {
      const value = state.searchText.toLowerCase();
      filter += ` and company.nome like '%${value}%'`;
    }
    return filter;
  },
};
